"use client";
import { Footer, Nav } from "@/components/bnp-ui";

import TermsAndConditions from "@/components/pages/auth/sign-up/TermsAndConditions";
import React from "react";

const TermsAndConditionsPage = () => {
  return (
    <div>
      <Nav />
      <div className="p-4 lg:p-8">
        <h1 className="text-2xl text-main-900 font-semibold mb-8">
          Terms and Conditions
        </h1>
        <TermsAndConditions />
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;
